import ApiService from '@/services/api.service'

const AuditSettingsService = {
    getAll(parameter) {
        const requestData = {
            method: 'get',
            url: "/WebAuditSettings/",
            headers: {
            },
            params: parameter
        }
        return ApiService.customRequest(requestData);
    },

    get(id) {
        return ApiService.get(`/WebAuditSettings/${id}`);
    },

    add(data){
        return ApiService.post(`/WebAuditSettings`,data)
    },

    delete(id){
        return ApiService.delete(`/WebAuditSettings/${id}`)
    },

    update(id,data){
        return ApiService.put(`/WebAuditSettings/${id}`,data)
    },
}

export default AuditSettingsService;